import { CREATE_TYPE_OF_HELP_FAIL, CREATE_TYPE_OF_HELP_REQUEST, CREATE_TYPE_OF_HELP_SUCCESS, FETCH_TYPE_OF_HELP_FAIL, FETCH_TYPE_OF_HELP_REQUEST, FETCH_TYPE_OF_HELP_SUCCESS, UPDATE_TYPE_OF_HELP_FAIL, UPDATE_TYPE_OF_HELP_REQUEST, UPDATE_TYPE_OF_HELP_SUCCESS } from "../../ActionType/SurgeryType/SurgeryType";

export const getTypeOfHelpReducer = (
    state = { loading: true, typeOfHelps: [], error: [] },
    action
  ) => {
    switch (action.type) {
      case FETCH_TYPE_OF_HELP_REQUEST:
        return {
          loading: true,
        };
      case FETCH_TYPE_OF_HELP_SUCCESS:
        return {
          loading: false,
          typeOfHelps: action.payload,
          error: "",
        };
      case FETCH_TYPE_OF_HELP_FAIL:
        return {
          loading: false,
          typeOfHelps: [],
          error: action.error,
        };
      default:
        return state;
    }
  };


export const createTypeOfHelpReducer = (
    state = { loading: true, typeOfHelps: [], error: [] },
    action
  ) => {
    switch (action.type) {
      case CREATE_TYPE_OF_HELP_REQUEST:
        return {
          loading: true,
        };
      case CREATE_TYPE_OF_HELP_SUCCESS:
        return {
          loading: false,
          typeOfHelps: action.payload,
          error: "",
        };
      case CREATE_TYPE_OF_HELP_FAIL:
        return {
          loading: false,
          typeOfHelps: [],
          error: action.error,
        };
      default:
        return state;
    }
  };

  
export const updateTypeOfHelpReducer = (
    state = { loading: true, typeOfHelps: [], error: [] },
    action
  ) => {
    switch (action.type) {
      case UPDATE_TYPE_OF_HELP_REQUEST:
        return {
          loading: true,
        };
      case UPDATE_TYPE_OF_HELP_SUCCESS:
        return {
          loading: false,
          typeOfHelps: action.payload,
          error: "",
        };
      case UPDATE_TYPE_OF_HELP_FAIL:
        return {
          loading: false,
          typeOfHelps: [],
          error: action.error,
        };
      default:
        return state;
    }
  };